export default __webpack_public_path__ + "static/media/too-many-works-desktop.7a63562e.png";